import React, { useState, useEffect } from "react";

import axios from "axios";
import { server } from "../../utills/utils";

import Shop from "../Shops/FavShop";
import NotFound from "../Common/NotFoundSearch";

import styled from "styled-components";

const Container = styled.div`
  width: 104%;
  height: 100%;
`;
const Title = styled.h2`
  padding: 0;
  margin: 0 0 20px 0;
  font-weight: 500;
`;
const AllShops = styled.div`
  width: 102%;
  display: flex;
  flex-flow: wrap;
`;

function Settings() {
  const [shops, setShops] = useState([]);
  const [complete, setComplete] = useState(false);

  const fetchShop = async () => {
    try {
      const shops = await axios.post(server, {
        query: `
                    query{
                      favouriteShops(token: "${localStorage.TOKEN}"){
                        _id
                        shop{
                          _id
                          name
                          coverImage
                          cityName
                          thanaName
                          userName
                        }
                      }
                    }
                    `,
      });
      console.log("Shops", shops);
      setShops(shops.data.data.favouriteShops);
      setComplete(true);
      // const updtedOrders = orders.filter(or=>{
      //     return or._id !== order._id
      // });
    } catch (error) {
      throw error;
    }
  };
  useEffect(() => {
    fetchShop();
  }, []);

  //console.log("Shops", shops);
  return (
    <Container>
      <Title>Favourite Shops</Title>
      <AllShops>
        {complete ? (
          shops && shops.length > 0 ? (
            shops.map((item) => {
              return <Shop key={item._id} shop={item.shop} />;
            })
          ) : (
            <NotFound
              title="No Favourites Shop"
              subTitle="Explore  more shop and happy shopping!."
            />
          )
        ) : (
          <p>Loading...</p>
        )}
      </AllShops>
    </Container>
  );
}

export default Settings;
